import React from "react";
import { string } from "prop-types";
import { classes } from "../utils/classes";
import pureFC from "../utils/pureFC";

const Form = ({ className, ...props }) => (
	<form className={classes("form form--stacked", className)} {...props} />
);

Form.propTypes = {
	className: string,
};

export default pureFC(Form);
